import Loader from "../components/loader"
import { IWindowOptions, Window } from "./window"


export async function ShowLoading(title: string, preConfirm: IWindowOptions['preConfirm'], options?: IWindowOptions) {
    const win = new Window();
    const { isConfirmed } = await win.fire({
        title,
        body: <div className="w-full flex items-center justify-center">
            <Loader size={12} />
        </div>,
        showCancelButton: false,
        showConfirmButton: false,
        showLoaderOnConfirm: false,
        allowEnterKey: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: () => win.clickConfirm(),
        preConfirm,
        ...options
    })
    return isConfirmed
}